import { useMutation } from '@tanstack/react-query';

import { fetchJson } from '../fetch';

export const useResendCoInvoice = (id: number) => {
  return useMutation({
    mutationFn: () => {
      return fetchJson(`/invoices/${id}/resend-co`, {
        method: 'POST',
      });
    },
  });
};
